export const THEMES_CONFIG = {
  default: 'Light Theme',
  dark: 'Dark Mode',
};
